import type React from "react";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { STATIC_PAGE_MESSAGES } from "~/constants/messages";
import companyLogo from "~/images/reqxign-logo-full.png";
import type { RootState } from "~/store";
import styles from "./index.module.scss";

const SignUp: React.FC = () => {
  const authState: RootState["auth"] | null = useSelector((state: RootState) => state.auth);
  const navigate = useNavigate();

  useEffect(() => {
    if (!authState || authState.signupAllowed !== true) {
      navigate("/");
    }
  }, [authState, navigate]);

  if (!authState || authState.signupAllowed !== true) {
    return null;
  }

  const bodyLines = STATIC_PAGE_MESSAGES.SIGNUP_CLOSED_BODY.split("\n").filter(
    (line) => line.trim() !== "",
  );

  return (
    <div className={styles["container"]}>
      <img src={companyLogo} alt="レクシン" className={styles["logo"]} />
      <h1 className={styles["title"]}>{STATIC_PAGE_MESSAGES.SIGNUP_CLOSED_TITLE}</h1>
      <div className={styles["body"]}>
        {bodyLines.map((line) => (
          <p key={line}>{line}</p>
        ))}
      </div>
    </div>
  );
};

export default SignUp;
